import styled from '@emotion/styled'
import { memo } from 'react'
import { FloaterSize } from '../../../constants/floaters'
import { RoomView } from '../../../state/modals'
import { SidebarType } from '../../../state/state.sidebar'
import { slugToID } from '../../../state/state.users'
import { useFloatingRoom } from '../../Hooks/useModal'
import { useRoomSelector } from '../../Hooks/useRoomAppState'
import { useRouteSelector } from '../../Hooks/useRoute'
import { useSidebarSelector } from '../../Hooks/useSidebar'
import { getThemeSpacing } from '../../styles/appTheme'
import { palette } from '../../styles/colors'
import { COMPONENT_WIDTHS } from '../../theme'
import Participants from '../Chat/Rooms/Participants'
import Connections from './Connections'

const SidebarRoot = styled('div')({
    display: 'flex',
    flex: '1 0 auto',
    position: 'relative' as const,
    width: COMPONENT_WIDTHS.sidebar,
    paddingLeft: getThemeSpacing(0.75),
    // paddingTop: getThemeSpacing(0.5),
    paddingRight: getThemeSpacing(0.25),
    background: palette.navBackground,
})
const SidebarContainer = styled('div')({
    display: 'block',
    width: '100%',
    height: '100%',
    // overflowX: 'hidden',
    overflowY: 'scroll',
    msOverflowStyle: 'none',
    // ...(NO_SCROLLBAR_STYLES as any),
})

interface ISidebar {
    authenticated: boolean
}

const Sidebar = memo(({ authenticated }: ISidebar) => {
    const type = useSidebarSelector('type')
    const [floatingRoom] = useFloatingRoom()
    const routeSlug = useRouteSelector('slug')
    const isMessagePage =
        floatingRoom.show &&
        floatingRoom.state.size === FloaterSize.Fullscreen &&
        floatingRoom.state.roomView === RoomView.PM
    const isRoomPage =
        floatingRoom.show &&
        floatingRoom.state.size === FloaterSize.Fullscreen &&
        floatingRoom.state.roomView === RoomView.Room
    const isRoomOrMessagePage = isRoomPage || isMessagePage

    const roomID = floatingRoom.state.id
    const id = isRoomPage
        ? roomID
        : isMessagePage
          ? slugToID[routeSlug]
          : undefined

    const isSubscribed = useRoomSelector(id, 'isSubscribed')

    const participants =
        type === SidebarType.Participants && isRoomOrMessagePage && isSubscribed

    const showSidebar = authenticated || participants
    if (!showSidebar) return null
    return (
        <SidebarRoot>
            <SidebarContainer
                className="no-scrollbars"
                data-testid="Container__Sidebar"
            >
                {participants ? (
                    <Participants id={id} sidebar />
                ) : (
                    <Connections />
                )}
            </SidebarContainer>
        </SidebarRoot>
    )
})

export default Sidebar
